export default __webpack_public_path__ + "static/media/india_icon.63ae9a51.svg";